import type { Component } from "solid-js";
import type { IconProps } from "./types";

const AutomationIcon: Component<IconProps> = (props) => {
  const size = props.size || 16;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      width={size}
      height={size}
      class={props.class}
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M4.5 2.25a.75.75 0 0 0-.75.75v16.5c0 .414.336.75.75.75h15a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75h-15ZM9 6.75h6m-6 3h6m-6 3h6m-6 3h3"
      />
    </svg>
  );
};

export default AutomationIcon;
